<template>
  <div v-if="$currentUser" class="wrapper" v-bind="$attrs" v-on="$listeners">
    <div class="wrapper_user-info">
      <span class="wrapper_user-info_name"> {{ $currentUser.fullName }} </span>
      <span v-if="positionLabel" class="wrapper_user-info_post"> {{ positionLabel }} </span>
    </div>

    <UiUserAvatar size="30px" :src="$currentUser.avatarUri" rounded />
  </div>
</template>

<script>
import currentUser from '@/mixins/currentUser'
import UiUserAvatar from '@/components/UiUserAvatar.vue'

export default {
  components: { UiUserAvatar },
  mixins: [currentUser],
  computed: {
    positionLabel() {
      return this.$currentUser && this.$currentUser.position
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  cursor: pointer;

  @include unselectable();
  @include createFlex(inline-flex, nowrap, row, flex-start, center, center);

  &_user-info {
    display: none;
    margin: 0 rem(16px) 0 0;
    text-align: right;

    @include media_tablet {
      @include createFlex(flexbox, nowrap, column, flex-end, stretch, stretch);
    }

    &_name {
      margin: 0 0 rem(3px) 0;
      color: $color-gray-600;
    }

    &_post {
      font-size: rem(11px);
      color: $color-gray-500;
    }
  }
}
</style>
